
import { MainLayout } from "@/components/layout/MainLayout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Shield } from "lucide-react";
import UserManagement from "./users/UserManagement";
import FileManagement from "./files/FileManagement";
import QAManagement from "./qa/QAManagement";
import NewsManagement from "./news/NewsManagement";
import ContentManagement from "./content/ContentManagement";

export default function AdminDashboard() {
  return (
    <MainLayout>
      <div className="container mx-auto py-10">
        <div className="flex items-center gap-2 mb-8">
          <Shield className="h-6 w-6 text-primary" />
          <h1 className="text-3xl font-bold">Περιβάλλον Διαχείρισης</h1>
        </div>
        
        <Tabs defaultValue="users">
          <TabsList className="mb-8">
            <TabsTrigger value="users">Διαχείριση Χρηστών</TabsTrigger>
            <TabsTrigger value="files">Διαχείριση Αρχείων</TabsTrigger>
            <TabsTrigger value="content">Διαχείριση Περιεχομένου</TabsTrigger>
            <TabsTrigger value="news">Νέα & Τεχνολογία</TabsTrigger>
            <TabsTrigger value="qa">Διαχείριση Q&A</TabsTrigger>
          </TabsList>
          
          <TabsContent value="users">
            <UserManagement />
          </TabsContent>
          
          <TabsContent value="files">
            <FileManagement />
          </TabsContent>
          
          <TabsContent value="content">
            <ContentManagement />
          </TabsContent>
          
          <TabsContent value="news">
            <NewsManagement />
          </TabsContent>
          
          <TabsContent value="qa">
            <QAManagement />
          </TabsContent>
        </Tabs>
      </div>
    </MainLayout>
  );
}
